<span *ngIf="casosExito_item">
  <a [routerLink]="['/casos-exito',casosExito_item.id]">
            <div class="col-lg-12 casos-exito-blq-inner-img">
          
              <div class="casos-exito-blq-inner-caption">
                <h1 [innerHTML]="casosExito_item.caption"></h1>
            </div> 
            <img [src]="img" class="img-full-cover" alt="{{casosExito_item.imgAlt}}"/>
                      
                            <div class="prensa-showcase__footer">
                            
                                    <div class="text">
                                      <span [innerHTML]="casosExito_item.title"></span>
                                </div>

                                <div class="forma">
                                    <div class="forma-blq"></div>
                                </div>

                              </div>
                      
                  </div>
      </a>
  </span>
            
